import { Injectable } from '@angular/core';

import { BaseEntityResource } from '../../core/abstractions/base-entity.resource';
import { ResourceConfig } from '../../models/core/resource.config';
import { SecurityModel } from '../../models/security.model';

@Injectable({
    providedIn: 'root'
})
export class SecuritiesResource extends BaseEntityResource<SecurityModel> {
    constructor() {
        super(new ResourceConfig({ baseController: 'securities' }));
    }
}
